export const TOGGLE_MODAL_LOYALTY_SHOP = 'TOGGLE_MODAL_LOYALTY_SHOP';

export function toggleModalLoyaltyShop(itemCode, loyaltyList) {
  return {
    type: TOGGLE_MODAL_LOYALTY_SHOP,
    itemCode,
    loyaltyList,
  };
}
